<template>
  <div
    :class="['loading-circle', 'show', `loading-circle--layout-${layout}`]"
  >
    <div 
      class="sk-fading-circle"
      :style="sizeStyle"
    >
      <div class="sk-circle1 sk-circle"></div>
      <div class="sk-circle2 sk-circle"></div>
      <div class="sk-circle3 sk-circle"></div>
      <div class="sk-circle4 sk-circle"></div>
      <div class="sk-circle5 sk-circle"></div>
      <div class="sk-circle6 sk-circle"></div>
      <div class="sk-circle7 sk-circle"></div>
      <div class="sk-circle8 sk-circle"></div>
      <div class="sk-circle9 sk-circle"></div>
      <div class="sk-circle10 sk-circle"></div>
      <div class="sk-circle11 sk-circle"></div>
      <div class="sk-circle12 sk-circle"></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  width?: number | string;
  height?: number | string;
  layout?: 'center' | 'inline';
}>(), {
  width: 40,
  height: 40,
  layout: 'center',
});

function toCssLength(value: number | string): string {
  if (typeof value === 'number') return `${value}px`;
  if (/^\d+$/.test(value)) return `${value}px`;
  return value;
}

const sizeStyle = computed(() => ({
  width: toCssLength(props.width),
  height: toCssLength(props.height),
}));
</script>

<style lang="scss">
.loading-circle--layout-inline {
  display: inline-flex !important;
  vertical-align: middle;
}

.loading-circle--layout-center {
  display: flex !important;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.loading-circle.show {
  .sk-fading-circle {
    margin: unset;
    position: relative;

    .sk-circle:before {
      background-color: var(--color-bluedeep);
    }
  }

}
</style>